import React from "react";
import ColButton from "../../../Elements/ColButton";
import FaIcon from "../../../Elements/FaIcon";
import LoadingIcon from "../../../Elements/LoadingIcon";
import OverWindow from "../../../Elements/OverWindow";
import ErrorMessage from "../../../Elements/ErrorMessage";
import PaymentExportAllExportService from "../../../Services/PaymentExportAllExportService";
import ButtonFooterContainer from "../../../Elements/ButtonFooterContainer";

export default class UploadPaymentReconciliationWindow extends React.Component {
  static defaultProps = {
    clickOnCancel: () => alert("Please, define the clickOnCancel function in the props."),
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedFile: null,
      saving: false,
    };
    this.fileUploadOnChange = this.fileUploadOnChange.bind(this);
  }

  componentDidMount() {}

  fileUploadOnChange(e) {
    if (e.target.files.length > 0) {
      this.setState({ selectedFile: e.target.files[0] });
    } else {
      this.setState({ selectedFile: null });
    }
  }

  onSubmit() {
    const data = new FormData();
    data.append("file", this.state.selectedFile);
    this.setState({ saving: true });
    PaymentExportAllExportService.postUploadPaymentReconciliationFile(data)
      // .then(result => {
      //     this.setState({ saving: false });
      //     ErrorMessage.SetNotification("File upload is successfull. You will find the result report in your personal message repository.")
      //     this.props.clickOnCancel(true);
      // })
      .catch((error) => {
        ErrorMessage.SetErrorMessage("Error! ErrorCode: UPRW48");
        // this.setState({ saving: false });
      });
    ErrorMessage.SetNotification("File upload is started. You will find the result report in your personal message repository.");
    this.props.clickOnCancel(true);
  }

  renderButtons() {
    return (
      <ButtonFooterContainer>
        <ColButton
          text="Cancel"
          onClick={this.props.clickOnCancel}
          disabled={this.state.saving}
        />
        <ColButton
          text="Upload File"
          type="submit"
          icon={"fa-solid fa-upload" + (this.state.loading ? " fa-spin" : "")}
          disabled={!this.state.selectedFile}
          spinning={this.state.saving}
        />
      </ButtonFooterContainer>
    );
  }

  render() {
    return (
      <OverWindow
        clickOnCancel={() => this.props.clickOnCancel(false)}
        title="Upload Payment Reconciliation File"
        closeOnClickOutside={false}
        iconName="fa-solid fa-upload"
        verticalScroll={true}
        maxWidth={1000}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            this.onSubmit();
          }}
        >
          <div className="m-2 p-2">
            <div className="p-1 m-1 h5 text-center">Select the payment reconciliation file and upload it.</div>
            <div className="custom-file d-flex justify-content-center align-items-center m-1 p-1">
              <FaIcon
                iconName="fa-solid fa-file-invoice-dollar"
                className="h3 text-primary p-1"
              />
              <input
                className="p-1"
                type="file"
                filter
                onChange={this.fileUploadOnChange}
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                id="fileupload"
              />
            </div>
          </div>
          <LoadingIcon loading={this.state.saving} />
          {this.renderButtons()}
        </form>
      </OverWindow>
    );
  }
}
